// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"224":"61b706a1","798":"b16b4f2f"}[chunkId] + ".css";
};